import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import NewCoreProductActionsBlockData from '../../../Models/Content/NewCoreProductActionsBlockData';
import NewCoreProductActionsMain from './NewCoreProductActionsMain'


export default class PopupBenefitBlock extends EpiComponent<NewCoreProductActionsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <NewCoreProductActionsMain context={this.getContext()} iContent={this.props.data} />
  }
}
